export const defaultTimezoneRegionId = 'Europe/Berlin';
